import './js/sentry';
import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';
import 'core-js/actual/structured-clone';
import('flatpickr/dist/themes/light.css');

Turbo.session.drive = false;

import './css/main.scss';
import './js/consent-payment';
import 'intl-tel-input/build/css/intlTelInput.css';

import ModalController from './controllers/modal_controller.js';
import AutosubmitFormController from './controllers/autosubmit_form_controller.js';
import BookingPackageInfoboxController from './controllers/booking_package_infobox_controller.js';
import BookingTravellersController from './controllers/booking_travellers_controller.js';
import DatepickerController from './controllers/datepicker_controller';
import FetchInsuranceController from './controllers/fetch_insurance_controller.js';
import FormSpinnerController from './controllers/form_spinner_controller.js';
import HelpCenterController from './controllers/help_center_controller.js';
import InputNumberController from './controllers/input_number_controller.js';
import LoginModalTravellersController from './controllers/login_modal_travellers_controller.js';
import MenuDesktopController from './controllers/menu_desktop_controller.js';
import MenuMobileController from './controllers/menu_mobile_controller.js';
import ObfuscatorController from './controllers/obfuscator_controller.js';
import OptionSelectorController from './controllers/option_selector_controller.js';
import PaymentController from './controllers/saga/payment_controller.js';
import PhoneInputController from './controllers/phone_input_controller.js';
import PopoverController from './controllers/popover_controller.js';
import RadioInputController from './controllers/radio_input_controller.js';
import RequestAsideController from './controllers/request_aside_controller';

// start the Stimulus application
import { startStimulusApp } from '@symfony/stimulus-bridge';

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
export const app = startStimulusApp();

app.register('modal', ModalController);
app.register('autosubmit-form', AutosubmitFormController);
app.register('booking-package-infobox', BookingPackageInfoboxController);
app.register('booking-travellers', BookingTravellersController);
app.register('datepicker', DatepickerController);
app.register('fetch-insurance', FetchInsuranceController);
app.register('form-spinner', FormSpinnerController);
app.register('help-center', HelpCenterController);
app.register('input-number', InputNumberController);
app.register('login-modal-travellers', LoginModalTravellersController);
app.register('menu-desktop', MenuDesktopController);
app.register('menu-mobile', MenuMobileController);
app.register('obfuscator', ObfuscatorController);
app.register('option-selector', OptionSelectorController);
app.register('saga--payment', PaymentController);
app.register('phone-input', PhoneInputController);
app.register('popover', PopoverController);
app.register('radio-input', RadioInputController);
app.register('request-aside', RequestAsideController);

registerSvelteControllerComponents(
    require.context('./svelte/saga/controllers', true, /\.svelte$/),
);
